import { Injectable } from '@angular/core';
import { AlertMessageService, User } from '@serpro/ngx-suite-rfb';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    constructor(
        private alertMessageService: AlertMessageService
    ) {}

    // Ex: hasIntersection([1, 2], [2, 3]) => true
    // Ex: hasIntersection([1, 2], [3]) => false
    public hasIntersection(itemsA: string[], itemsB: string[]): boolean {
        if (itemsA && itemsA.length > 0) {
            for (const itemA of itemsA) {
                if (itemsB.findIndex(itemB => itemB === itemA) >= 0) {
                    return true;
                }
            }
        }
        return false;
    }

    public static contemRole(user: User, role: string): boolean {
        if (user && user.roles && role) {
            if (user.roles.findIndex(r => r.id === role) >= 0) {
                return true;
            }
        }
        return false;
    }
}
